import api from './api';

export const usuarioExtensaoService = {
  // Listar todos os acessos usuario-extensao com filtros e paginação
  list: async (params = {}) => {
    try {
      const response = await api.get('/usuario-extensoes', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao carregar acessos usuário-extensão:', error);
      throw new Error(error.response?.data?.message || 'Erro ao carregar acessos usuário-extensão');
    }
  },

  // Buscar acesso por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/usuario-extensoes/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao carregar acesso usuário-extensão:', error);
      throw new Error(error.response?.data?.message || 'Erro ao carregar acesso usuário-extensão');
    }
  },

  // Criar novo acesso usuario-extensao
  create: async (data) => {
    try {
      const response = await api.post('/usuario-extensoes', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar acesso usuário-extensão:', error);
      throw new Error(error.response?.data?.message || 'Erro ao criar acesso usuário-extensão');
    }
  },

  // Atualizar acesso usuario-extensao
  update: async (id, data) => {
    try {
      const response = await api.put(`/usuario-extensoes/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar acesso usuário-extensão:', error);
      throw new Error(error.response?.data?.message || 'Erro ao atualizar acesso usuário-extensão');
    }
  },

  // Deletar acesso usuario-extensao
  delete: async (id) => {
    try {
      const response = await api.delete(`/usuario-extensoes/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover acesso usuário-extensão:', error);
      throw new Error(error.response?.data?.message || 'Erro ao remover acesso usuário-extensão');
    }
  },

  // Buscar extensões de um usuário específico
  getExtensoesByUsuario: async (usuarioId) => {
    try {
      const response = await api.get(`/usuario-extensoes/usuario/${usuarioId}/extensoes`);
      return response.data;
    } catch (error) {
      console.error('Erro ao carregar extensões do usuário:', error);
      throw new Error(error.response?.data?.message || 'Erro ao carregar extensões do usuário');
    }
  },

  // Verificar se usuário tem acesso a uma extensão
  verificarAcesso: async (usuarioId, extensaoId) => {
    try {
      const response = await api.get(`/usuario-extensoes/verificar/${usuarioId}/${extensaoId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao verificar acesso:', error);
      throw new Error(error.response?.data?.message || 'Erro ao verificar acesso');
    }
  },

  // Adicionar múltiplos acessos em lote
  adicionarAcessosLote: async (usuarioId, extensaoIds, cadastradoPor, dataInicio = null, dataFim = null, observacoes = null) => {
    try {
      const payload = {
        usuario_id: usuarioId,
        extensao_ids: extensaoIds
      };

      // Adicionar campos opcionais apenas se tiverem valores
      if (dataInicio) {
        payload.data_inicio = dataInicio;
      }
      if (dataFim) {
        payload.data_fim = dataFim;
      }
      if (observacoes) {
        payload.observacoes = observacoes;
      }

      const response = await api.put('/usuario-extensoes/lote', payload);
      return response.data;
    } catch (error) {
      console.error('Erro ao adicionar acessos em lote:', error);
      throw new Error(error.response?.data?.message || 'Erro ao adicionar acessos em lote');
    }
  }
};

export default usuarioExtensaoService;
